import axios from 'axios';
import router from '@/router/index';
//import qs from 'qs';

axios.defaults.timeout = 30*1000*60;
//axios.defaults.baseURL = process.env.BASE_URL;

//使用拦截器统一处理所有的http请求
//http request 拦截器 在发送请求之前做些什么
axios.interceptors.request.use(
  config => {            
    // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
    config.data = JSON.stringify(config.data);
    config.headers = {
      'Content-Type':'application/json',
      //'Authorization': 'Bear '+ sessionStorage.getItem('token'),
    }
    // config.validateStatus = status => {
    //   return (status >= 200 && status < 300) || status == 401 || status == 500; // default
    // }    
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);


//http response 拦截器  对响应数据做点什么
axios.interceptors.response.use(
  response => {
    if(response.data.code == 401 || response.data.code == 10000){
      router.push({
        path:"/login"
      })
      return;
    }
    return response;
  },
  error => {
    return Promise.reject(error)
  }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url:string,params={}){
  return new Promise((resolve,reject) => {
    axios.get(url,{
      params:params,
      paramsSerializer: function (params) {
          return $.param(params).replace(/%5B%5D=/g, '=');
      }
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(err => {
      reject(err)
    })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

 export function post(url:string,data = {},time = axios.defaults.timeout){
   return new Promise((resolve,reject) => { 
     axios.post(url,data,{timeout: time})
          .then(response => {
            resolve(response.data);
          },err => { 
            reject(err)
          })
   })
 }

 /**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url:string,data = {}){
  return new Promise((resolve,reject) => {
    axios.patch(url,data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}

 /**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url:string,data = {}){
  return new Promise((resolve,reject) => {
    axios.put(url,data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}

/**
 * 封装delete方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function toDelete(url:string,params={}){
  return new Promise((resolve,reject) => {
    axios.delete(url,{
      params:params
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(err => {
      reject(err)
    })
  })
}